import React from 'react';

import { Skeleton, TableCell } from '@mui/material';

import { getHeadCellStyles } from './SimpleTable.styles';

const SkeletonCell = () => (
  <TableCell className="table-cell" sx={getHeadCellStyles({ width: '100%' })}>
    <Skeleton height={21} variant="rounded" />
  </TableCell>
);

export default SkeletonCell;
